/**
 * Created by DELL on 2017/6/5.
 */

import React, { Component } from 'react'
import './style.scss'
import { NavLink } from 'react-router-dom';
import { openNewLink } from '../../utils/index';
import { getAuth } from '../../service/common';
class SecondMenu extends Component {
    toTarget = menu => {
        getAuth({
            appId: 'X2573I9Q5E',
            redirectUrl: menu.redirectUrl
        }).then(({ result }) => {
            openNewLink(result.location);
        })
    }
    render() {
        const { menus} = this.props;
        let menusDom = menus.map(item=> {
            if (item.menuName === '数据监控中心') {
             
                return <li  onClick={this.toTarget.bind(this, item)}>
                    <a>{item.menuName}</a>
                </li>;
            }
            return <NavLink key={item.menuName} className={item.menuName == '知识列表' && this.props.titleId == 1 ? 'menuSelect' : ' '} to={item.linkTo} activeClassName='menuSelect'>
                <li>{item.menuName}</li>
            </NavLink>
        })
     
        return <ul>{menusDom}</ul>
    }
}


export default SecondMenu